import { createContext, useContext } from 'react';

export const EventSettingsContext = createContext();

export function useEventSettings() {
  return useContext(EventSettingsContext);
}
